var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamond02 = function SvgDiamond02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.278 22.743a1.75 1.75 0 0 1-1.278.535q-.742 0-1.278-.535l-9.465-9.465A1.75 1.75 0 0 1 .721 12q.001-.742.536-1.278l9.465-9.465A1.75 1.75 0 0 1 12 .722q.742 0 1.278.535l9.464 9.465q.536.536.536 1.278t-.536 1.278zm-1.06-1.061 9.464-9.464a.3.3 0 0 0 .081-.218.3.3 0 0 0-.081-.218l-9.465-9.464A.3.3 0 0 0 12 2.237a.3.3 0 0 0-.218.081l-9.464 9.464a.3.3 0 0 0-.082.218q0 .135.082.218l9.464 9.464a.3.3 0 0 0 .218.081q.136 0 .217-.081"
  })));
};
export default SvgDiamond02;